import script from "./Scrambles.vue?vue&type=script&lang=ts&setup=true"
export * from "./Scrambles.vue?vue&type=script&lang=ts&setup=true"

import "./Scrambles.vue?vue&type=style&index=0&id=1e1af279&lang=scss"

const __exports__ = script;

export default __exports__